// extracted by mini-css-extract-plugin
module.exports = {"tableHeader":"CampaignList_tableHeader__3WsrM"};